// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ModalTerms_modalOverlay__DUbkL","modalContent":"ModalTerms_modalContent__ARIHR","closeButton":"ModalTerms_closeButton__-9Rxo"};